import { render } from "./BrandHero.vue?vue&type=template&id=5ed57679&scoped=true"
import script from "./BrandHero.vue?vue&type=script&lang=js"
export * from "./BrandHero.vue?vue&type=script&lang=js"

import "./BrandHero.vue?vue&type=style&index=0&id=5ed57679&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ed57679"]])

export default __exports__